// src/apiService.js
import axios from 'axios'; // Make sure this line is present

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`; // Replace with your actual API base URL

const getAuthKey = () => {
    return `${process.env.REACT_APP_API_SECURITY_KEY}`;
  };

export const registerRole = async (userData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/roles/save`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': `${getAuthKey()}`,
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      alert('Network response was not ok');
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    // Check for specific status codes in the response
    if (data.statusCode === 1002) {
      // Returning a specific error message if the user already exists
      return { error: 'Role already exists' };
    }else if(data.statusCode===1001){
      return { success: 'Added Successfully' };
    }else{
      return { error: 'Fail' };
    }
    return data; // Return the API response
  } catch (error) {
    console.error('Error submitting form:', error);
    throw error; // Re-throw the error for handling in the component
  }
};


// Fetch all countries from the API
export const fetchRoleData = async (clientId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/admin/roles/getroleslist/${clientId}`,
      {
        headers: {
          'auth_key': `${getAuthKey()}`,
        }
      }
    );
    return response.data; // Return the list of countries
  } catch (error) {
    console.error('Error fetching countries:', error);
    alert('Error fetching countries:'+ error);
    throw error;
  }
};

// Fetch all countries from the API
export const fetchRoleDataById = async (roleId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/admin/roles/getrole/${roleId}`,
      {
        headers: {
          'auth_key': `${getAuthKey()}`,
        }
      }
    );
    return response.data; // Return the list of countries
  } catch (error) {
    console.error('Error fetching Data:', error);
    alert('Error fetching Data:', error);
    throw error;
  }
};


export const updateRole = async (userData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/role/updaterole`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': `${getAuthKey()}`,
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      alert('Network response was not ok');
      throw new Error('Network response was not ok');
    }

    const data = await response.json();// Check for specific status codes in the response
    if (data.statusCode === 1002) {
      // Returning a specific error message if the user already exists
      return { error: data.result };
    }else if(data.statusCode===1001){
      return { success: 'Updated Successfully' };
    }else if(data.statusCode===1003){
        return { error: data.result };
    }
    else if(data.statusCode===1004){
        return { error: data.result };
    }else{
      return { error: 'Fail' };
    }
    alert(data);
    return data; // Return the API response
  } catch (error) {
    console.error('Error submitting form:', error);
    alert('Error submitting form:', error);
    throw error; // Re-throw the error for handling in the component
  }
};

